module.exports = __webpack_public_path__ + "img/end_cave_world_cave.4ecb88a8.png";